import React from 'react';

export default function Touch(props) {
    return (
        <svg
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 512.000000 512.000000"
            preserveAspectRatio="xMidYMid meet"
            {...props}
        >
            <g
                transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                fill={props.color || '#000000'}
                stroke="none"
            >
                <path
                    d="M2463 5102 c-243 -87 -273 -424 -48 -543 l45 -24 0 -177 0 -178 -27
0 c-89 -1 -280 -70 -390 -142 -228 -149 -379 -372 -434 -643 -16 -77 -16 -263
0 -340 66 -322 264 -576 555 -711 l76 -35 0 -165 0 -166 -41 37 c-168 151
-437 99 -536 -104 -25 -49 -28 -67 -27 -146 l0 -90 158 -410 c87 -225 178
-450 204 -499 89 -173 250 -358 395 -456 l66 -45 1 -92 c0 -103 11 -138 51
-159 41 -21 1207 -21 1248 0 40 21 51 56 51 159 0 92 0 93 29 110 49 29 141
117 193 187 61 80 109 179 140 285 23 79 23 86 23 605 0 515 0 526 -21 571
-54 117 -165 189 -291 189 -44 0 -89 -6 -114 -17 -39 -15 -42 -15 -51 2 -26
45 -88 101 -143 127 -81 38 -185 40 -261 4 l-52 -24 -33 34 c-54 56 -141 94
-213 94 l-61 0 68 38 c245 134 423 376 482 655 24 109 20 153 -14 188 -39 39
-89 40 -131 2 -26 -24 -32 -41 -45 -117 -31 -177 -108 -321 -239 -443 -41 -38
-101 -84 -135 -102 l-61 -32 0 137 0 137 59 61 c99 104 145 222 143 366 -1
105 -27 194 -80 276 -178 274 -550 324 -792 107 -111 -100 -170 -231 -172
-383 -2 -144 44 -262 143 -366 l59 -61 0 -137 0 -137 -62 33 c-83 44 -222 182
-276 273 -141 241 -141 539 0 780 49 83 180 216 261 264 249 147 541 147 791
1 85 -50 125 -52 167 -11 53 54 37 118 -44 171 -99 65 -307 140 -389 140 l-28
0 0 178 1 177 51 30 c161 93 194 314 69 458 -72 81 -213 117 -318 79z m146
-196 c67 -35 65 -143 -4 -174 -51 -23 -107 -7 -131 39 -47 91 44 182 135 135z
m49 -1371 c123 -37 222 -167 224 -295 2 -67 -8 -130 -20 -130 -4 0 -13 14 -21
32 -21 46 -88 109 -146 138 -41 20 -65 25 -135 25 -70 0 -94 -5 -135 -25 -58
-29 -125 -92 -146 -138 -8 -18 -17 -32 -21 -32 -12 0 -22 63 -20 128 4 211
212 358 420 297z m-14 -464 l31 -31 5 -789 c5 -867 1 -810 68 -838 27 -11 37
-11 66 1 66 27 66 29 66 349 0 311 2 327 54 361 14 9 44 16 66 16 22 0 52 -7
66 -16 52 -34 54 -50 54 -361 0 -320 0 -322 66 -349 29 -12 39 -12 68 0 65 27
66 33 66 309 0 265 4 287 52 321 29 21 107 21 136 0 48 -34 52 -56 52 -321 0
-276 1 -282 66 -309 29 -12 39 -12 68 0 62 26 66 40 66 239 0 190 6 219 52
251 32 23 109 21 140 -4 49 -38 49 -44 46 -566 l-3 -489 -27 -73 c-53 -146
-148 -266 -275 -347 -34 -22 -67 -50 -72 -63 -6 -13 -11 -54 -11 -92 l0 -70
-475 0 -475 0 0 74 c0 90 -9 103 -123 179 -167 112 -325 303 -400 482 -82 197
-300 786 -304 820 -8 80 56 148 138 147 77 -1 95 -21 199 -221 96 -186 115
-210 168 -211 30 0 77 25 88 47 5 10 11 356 14 770 l5 751 25 27 c33 36 57 46
104 41 27 -3 49 -14 70 -35z"
                />
                <path
                    d="M3277 3665 c-34 -34 -40 -67 -23 -110 17 -41 71 -69 111 -59 43 11
75 52 75 96 0 85 -104 132 -163 73z"
                />
                <path
                    d="M528 3577 c-104 -39 -182 -110 -226 -206 -23 -47 -27 -70 -27 -146 0
-82 3 -97 33 -157 86 -176 285 -256 467 -187 75 28 172 121 201 191 l19 48
120 1 c148 0 184 11 208 61 16 32 17 43 7 73 -19 59 -37 65 -191 65 l-138 0
-25 55 c-33 73 -103 145 -173 180 -48 24 -73 29 -148 32 -59 2 -103 -1 -127
-10z m210 -213 c15 -11 37 -40 50 -65 59 -113 -20 -241 -148 -241 -145 0 -219
161 -128 278 12 14 35 33 52 40 44 20 139 13 174 -12z"
                />
                <path
                    d="M4360 3574 c-95 -34 -175 -109 -217 -201 l-24 -53 -138 0 c-154 0
-172 -6 -191 -65 -10 -30 -9 -41 7 -73 24 -50 60 -61 208 -61 l120 -1 19 -48
c29 -70 126 -163 201 -191 182 -69 381 11 467 187 30 60 33 75 33 157 0 76 -4
99 -27 147 -35 76 -104 148 -175 183 -48 24 -73 29 -148 32 -65 2 -103 -1
-135 -13z m218 -210 c15 -11 37 -40 50 -65 59 -113 -20 -241 -148 -241 -145 0
-219 161 -128 278 12 14 35 33 52 40 44 20 139 13 174 -12z"
                />
            </g>
        </svg>
    );
}
